class VaultQueryKeys {
  constructor(private prefix: string) {}

  getVaultInfo() {
    return [this.prefix, 'info'];
  }

  getPreferences() {
    return [this.prefix, 'preferences'];
  }
}

export default VaultQueryKeys;
